<div style="width:100%;height:100px;border:1px solid #002F87;background-color:#6FCFEB;">

    <div style="margin-top:20px;height:30px;">
        <span class="d-flex justify-content-center align-items-center">
            <span class="ace-secondary-text-14pt-semi" style="font-size:36px;font-weight: bold !important;color: white;">{{displayText}}</span>
        </span>
    </div>
    
    <div style="width:80%;margin-left:auto;margin-right:auto;margin-top:25px;">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
    
</div>
